<template>
  <LocaleLink
    class="link"
    :class="{ 'font-bold underline': active }"
    :href="href"
  >
    <slot
      >{{ $t("legal_text.middleColumn.navigation.until")
      }}{{ parseDate(paragraph.valid_until) }}
    </slot>
  </LocaleLink>
</template>

<script setup lang="ts">
import type { ILegalTextParagraph } from "~/models/ILegalTextParagraph";
import { parseDate } from "~/utils/dates";

type Props = {
  active?: boolean;
  paragraph: ILegalTextParagraph;
};

const props = withDefaults(defineProps<Props>(), { active: false });

const { href } = useOldParagraphLink(() => props.paragraph);
</script>
